module.exports = __webpack_public_path__ + "static/media/ict.456480fb.jpg";